import React, { useState } from 'react';
import Radio from "../../../form/Radio";
import Textarea from "../../../form/Textarea";
import Button from "../../../forms/Button";

const CancelOrderModalContent = ({ setModalClose }) => {
  const [reasonForCancellation, setReasonForCancellation] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const radioOptions = [
    "Ordered by mistake",
    "Item no longer needed",
    "Delivery is taking too long",
    "Ordered wrong item/variant",
    "Changed my mind",
    "Placed a duplicate order",
    "Payment issue",
    "Other (please specify)"
  ];

  const isOtherSelected = reasonForCancellation === "Other (please specify)";

  return (
    <>
      <div className="space-y-6">
        <div className="space-y-2">
          <h3 className="text-2xl font-medium text-md-dark">Are you sure, you want to cancel the order?</h3>
          <div className="text-base text-slate-500">By canceling your order, the items in this order will no longer be processed or delivered. If payment has already been made, a refund will be issued according to our refund policy.</div>
          <div className="text-sm text-slate-500">If you have any questions or need help, feel free to contact our support team.</div>
        </div>
        <div className="relative space-y-2">
          <h3 className="text-lg font-medium text-md-dark">Please select a reason for cancelling your order:</h3>
          <div className="relative grid grid-cols-2 gap-x-4 gap-y-2">
            {radioOptions.map((label, index) => (
              <Radio
                key={index}
                id={`reason-${label}`}
                radioName="reasonForCancellation"
                radioInputClass=""
                radioLableClass="font-normal"
                isChecked={reasonForCancellation === label}
                radioLabel={label}
                value={label}
                onChange={(e) => setReasonForCancellation(e.target.value)}
              />
            ))}
          </div>
          {isOtherSelected && (
            <div className="relative">
              <Textarea inputPlaceholder={"Please specify your reason"} value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
        <div className="ml-auto flex-shrink-0 flex items-center gap-1 md:gap-2">
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-xmark"} buttonIconPosition={"left"} buttonLabel={"Close"} buttonClasses={"!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
          <Button buttonHasLink={false} buttonIcon={"fa-regular fa-fw fa-paper-plane-top"} buttonIconPosition={"left"} buttonLabel={"Submit"} buttonClasses={"!h-10 !rounded-md !px-3"} buttonLabelClasses={"!font-medium !pb-1 !leading-none"} buttonFunction={() => setModalClose(false)} />
        </div>
      </div>
    </>
  );
};

export default CancelOrderModalContent;